import isString from 'lodash/isString';
import type { MenuItemConfig, PathValue, SelectedKeyResult } from './types';

export const getPathnameWithoutQuery = (value: PathValue): string => {
  if (!value) {
    return '';
  }

  const cleanPath = Array.isArray(value) ? value.find((item) => item && item !== '') || '' : isString(value) ? value : '';

  const normalizedPath = cleanPath.startsWith('/') ? cleanPath.slice(1) : cleanPath;

  return normalizedPath.split('?')[0].replace(/\/$/, '');
};

const getMatchScore = (currentPath: string, navLink: string): number => {
  const currentPathArr = currentPath.split('/');
  const navLinkArr = navLink.split('/');

  let matchScore = 0;

  for (let i = 0; i < Math.min(currentPathArr.length, navLinkArr.length); i += 1) {
    if (currentPathArr[i] === navLinkArr[i]) {
      matchScore += 1;
    }
  }

  return matchScore;
};

export const findOpenedKeys = (items: MenuItemConfig[], selectedKey: string): string[] => {
  let result: string[] = [];

  const findParents = (nestedItems: MenuItemConfig[], key: string, parents: string[] = []): void => {
    nestedItems.forEach((item) => {
      if (item.id === key) {
        result = parents;
      }

      if (item.children) {
        findParents(item.children, key, item.id ? [...parents, item.id] : parents);
      }
    });
  };

  findParents(items, selectedKey);

  return result;
};

export const findSelectedKeys = (currentLocation: string, items: MenuItemConfig[]): string | null | undefined => {
  let result: SelectedKeyResult = { key: null, matchScore: 0 };

  const searchElement = (nestedItems: MenuItemConfig[]): void => {
    nestedItems.forEach((item) => {
      if (item.children) {
        searchElement(item.children);
        return;
      }

      const matchScore = getMatchScore(currentLocation, getPathnameWithoutQuery(item.navLink));

      if (matchScore > result.matchScore) {
        result = { key: item.id, matchScore };
      }
    });
  };

  searchElement(items);

  return result.key;
};
